import { render, staticRenderFns } from "./Schart.vue?vue&type=template&id=b892ae46&scoped=true"
import script from "./Schart.vue?vue&type=script&lang=js"
export * from "./Schart.vue?vue&type=script&lang=js"
import style0 from "./Schart.vue?vue&type=style&index=0&id=b892ae46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b892ae46",
  null
  
)

export default component.exports